import React, { SyntheticEvent } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { CONTROL_MARGIN } from "../../../MuiThemes";
import { useLiveQuery } from "dexie-react-hooks";
import { TicketDatabase } from "../../../Utils/TicketDatabase";
import { LineItemTypeControlProps } from "../../../Utils/Interfaces";
import { TicketLineItemType } from "../../../sharedCode/avroGraphql";
import { propertyHasErrors } from "../inputHelpers";

export default function LineItemTypeSelector(props: LineItemTypeControlProps): JSX.Element {
    const lineItemTypeList = useLiveQuery(async () => TicketDatabase.ticketLineItemType.toArray());

    if (!lineItemTypeList) return <></>;

    const sortedList = lineItemTypeList.sort((a: TicketLineItemType, b: TicketLineItemType) => {
        return a.id - b.id; // TODO should probably have a sort order field on TicketLineItemType
    });

    const filteredList = sortedList.filter((li) => props.idList.findIndex((id) => id === li.id) >= 0);

    const initialValue = lineItemTypeList.find((p) => p.id === props.initialValue);

    return (
        <>
            <Autocomplete
                disabled={props.isDisabled}
                disableClearable={props.isRequired}
                value={initialValue === undefined ? null : initialValue}
                options={filteredList}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={handleOnChange}
                getOptionLabel={(li: TicketLineItemType) => li.label.toLocaleUpperCase()}
                filterSelectedOptions
                renderInput={(params) => (
                    <TextField
                        {...params}
                        margin={CONTROL_MARGIN}
                        error={propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                        label={props.labelText}
                    />
                )}
            />
        </>
    );

    function handleOnChange(e: SyntheticEvent, value: string | TicketLineItemType | null) {
        if (value === null) {
            // Required selectors should never persist an empty value.
            if (props.isRequired) {
                return;
            }
            props.mergeChanges(props.sourceId, { [props.sourceProperty]: undefined });
            return;
        }

        const newId = (value as TicketLineItemType).id;
        props.mergeChanges(props.sourceId, { [props.sourceProperty]: newId });
    }
}
